<div class="data-empty {{custClass}}">

  <ng-lottie *ngIf="!img" [options]="options"></ng-lottie>

  <img [src]="img" *ngIf="img" alt="">
  <h3 *ngIf="title && !hideTitle">{{title}}</h3>
  <p *ngIf="subTitle"> {{subTitle}}</p>
  <p *ngIf="desc">{{desc}}</p>
  <a *ngIf="linkBoolean" mat-raised-button color="primary" class="{{btnClass}}" (click)="evEmit()">
    {{link}}
  </a>
</div>